import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import SideBarMenuStikcy from "design-system/resources/html/components/common/sidebar/sidebar";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";

import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForGlideSlide from './glide';
import addItemSessionStorage from "./addItemSessionStorage";
import mParticleLogEvent from "./mParticleLogEvent";

window.onload = function () {
  Header();
  NavbarMobile();
  getIdCarouselForAutoSlide();
  getIdCarouselForGlideSlide();
  ResponsiveTable();
  RiskWarningBar();
  mParticleLogEvent();
  addItemSessionStorage();
  SideBarMenuStikcy();
};